import { Loader2 } from 'lucide-react'

interface LoadingOverlayProps {
  show: boolean
  label?: string
}

export function LoadingOverlay({ show, label }: LoadingOverlayProps) {
  if (!show) return null
  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-3 bg-background/80">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      {label && <p className="text-sm text-muted-foreground">{label}</p>}
    </div>
  )
}
